import { useState, useEffect } from 'react';
import { Shield, HelpCircle } from 'lucide-react';
import { useSiteConfig } from '../../hooks/useSiteConfig';
import { SiteFiling } from '../../components/common/SiteFiling';

// 隐私政策内容
const privacyContent = [
  {
    id: 1,
    title: '隐私政策概述',
    content: `1.1 活动精英订单预约管理系统（订单预约管理平台，以下简称"本平台"）由郑州捕风捉影文化传播有限公司（以下简称"我们"或"运营方"）开发与运营。本隐私政策说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您可行使的权利。

1.2 本平台面向活动执行者、自由职业人员及中小企业，是订单预约与对账核算的管理工具。本平台不代收代付、不参与订单交易与结算，也不保管您的交易资金或资金凭据。

1.3 请在使用本平台前仔细阅读本隐私政策。一旦您注册账户或使用本平台的任何功能，即表示您已阅读并同意本隐私政策。`
  },
  {
    id: 2,
    title: '我们收集的信息',
    content: `2.1 注册与登录信息：用户名、电子邮箱、手机号、登录密码，以及用于登录校验的验证码与登录凭据。

2.2 实名认证信息：为落实"用户即客户、系统内身份唯一"，注册时我们可能要求您提供真实姓名与身份证件信息用于身份核验。

2.3 个人资料信息：您主动填写的头像、昵称、地区、地址、紧急联系人及其电话、个人简介等。

2.4 业务数据：您创建的订单、订单项、金额、付款与结算记录、备注、人员调用（派工）、对账与分享记录，以及您名下的客户档案与自定义类型、标签。

2.5 使用与设备信息：为保障账号安全，我们记录登录设备信息、登录时间、来源 IP 与浏览器／系统类型，以及关键操作的留痕日志。

2.6 我们不会主动收集与上述目的无关的个人信息。`
  },
  {
    id: 3,
    title: '实名认证信息的特别处理',
    content: `3.1 收集目的：本平台内的订单基于真实的用户／客户身份而存在，错误的身份将导致错误的订单归属与核算，故需要在注册环节进行身份认证。

3.2 验证时点：身份验证仅在注册环节进行，验证通过后不在日常使用中重复采集。

3.3 存储与访问：验证后的身份信息在系统内加密存储，不用于展示，也不会被其他用户调用。

3.4 身份唯一与合并：已认证身份高于系统内未认证身份；对重复身份，我们将未认证的用户／客户身份向已认证的对应身份合并或清理，并保留必要的合并留痕。

3.5 注销删除：您注销账号时，关键身份信息随注销一并删除。`
  },
  {
    id: 4,
    title: '信息使用方式',
    content: `4.1 提供服务：使用相关信息为您提供订单管理、预约调度、客户管理、对账核算等本平台的各项功能。

4.2 账号与安全：用于身份验证、登录设备管理、防止欺诈与滥用，保障账号与数据安全。

4.3 消息通知：向您发送与服务相关的通知，如审核提醒、档期催办、结算与系统消息等。

4.4 改进服务：在合法、必要的范围内分析使用情况，以改进平台功能与服务质量。

4.5 我们不会将您的个人信息用于上述目的之外的商业用途，也不会出售您的个人信息。`
  },
  {
    id: 5,
    title: '跨用户可见与信息共享',
    content: `5.1 交易对方的可见性：本平台以"订单"连接交易双方。您创建的订单，其约定的对方（客户／交易对象）在与该订单相关的范围内可见相应内容（如订单信息、金额、状态与审核记录），以便双方对账核对。这是平台正常功能所必需，不构成越权使用。

5.2 派工与人员的可见性：涉及人员调用（派工）的订单，被调用人员在其相关范围内可见必要的订单信息。

5.3 服务商：在必要情况下，我们会委托第三方服务商（如短信、邮件、对象存储、第三方支付机构）处理信息，并要求其按约定保护您的信息安全。会员费通过第三方持牌支付机构收取，本平台不自行归集或保管用户资金。

5.4 法律要求：根据法律法规、有权机关的强制性要求，我们可能会提供相应信息。

5.5 除上述情形外，未经您的同意，我们不会向第三方共享您的个人信息。`
  },
  {
    id: 6,
    title: '信息存储与保护',
    content: `6.1 存储地点：您的信息存储在我们管理的位于中华人民共和国境内的安全服务器上。

6.2 保护措施：我们采取加密存储、传输加密、访问控制、凭证脱敏与操作留痕等措施保护您的信息，防止未经授权的访问、泄露、篡改或丢失；但请理解互联网环境不存在绝对安全。

6.3 存储期限：本平台不按时间自动删除或归档您的业务数据，没有"到期清空"机制；订单等为软删除，记录在满足对账与法定留存要求期间予以保留。

6.4 注销与删除：您注销账号后，我们删除或匿名化处理您的关键个人信息，法律法规要求留存的除外。`
  },
  {
    id: 7,
    title: 'Cookie 与登录会话',
    content: `7.1 为保障您持续登录与操作安全，本平台使用必要的会话凭据（含 HttpOnly 的登录令牌）在设备与服务器之间维持登录状态；这类凭据仅用于身份识别与会话续期。

7.2 您可通过退出登录或清除浏览器数据移除本地会话信息；退出后相关令牌将被吊销。`
  },
  {
    id: 8,
    title: '您的权利',
    content: `8.1 访问与更正：您有权在"个人中心"查看、访问并更正、更新您的个人资料信息。

8.2 导出备份：您可在"设置 → 数据与隐私"导出本人账本的数据备份（尊享会员功能），以便自行留存与迁移交接。

8.3 删除：您可通过取消订单、删除资料等方式处置您的业务数据；订单不能由用户直接删除，只能取消，彻底删除需联系客服。

8.4 撤回同意与注销：您可撤回对信息收集和使用的同意或申请注销账号，但这可能影响您使用相关服务功能。

8.5 行使权利：如需行使上述权利或对本政策有疑问，请通过"联系我们"与我们取得联系。`
  },
  {
    id: 9,
    title: '未成年人保护',
    content: `9.1 本平台主要面向具有完全民事行为能力的用户，不面向未成年人提供注册与交易管理服务。

9.2 我们已在注册验证环节限制了未成年人的注册，但无法完全保证验证的准确性；我们如发现未经核实的孩子信息，将第一时间删除清理，相关订单也将一并清除。`
  },
  {
    id: 10,
    title: '政策更新与联系我们',
    content: `10.1 政策更新：我们可能不时更新本隐私政策，更新后的政策将在本页面公布；继续使用本平台表示您同意更新后的隐私政策。

10.2 联系我们：如您对本隐私政策有任何疑问、意见或行权请求，欢迎通过平台"联系我们"页面与我们取得联系，我们将在 7 个工作日内回复。`
  }
];

export default function PrivacyPage() {
  const { siteName, logoUrl } = useSiteConfig();
  const [isScrolled, setIsScrolled] = useState(false);

  // 监听滚动事件，控制导航栏样式
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* 顶部导航 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 h-[70px] transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-slate-100' : 'bg-transparent'}`}>
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 h-full flex items-center justify-between">
          <a href="/login" className="flex items-center gap-3">
            <img 
              src={logoUrl} 
              alt="Logo" 
              className="w-10 h-10"
            />
            <span className={`text-lg font-bold tracking-wide transition-colors ${isScrolled ? 'text-slate-800' : 'text-white'}`}>
              {siteName}
            </span>
          </a>
          <div className="flex items-center gap-6">
            <a href="/help" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:opacity-70' : 'text-white/90 hover:text-white'}`}>
              帮助中心
            </a>
            <a href="/about" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:opacity-70' : 'text-white/90 hover:text-white'}`}>
              关于我们
            </a>
            <a href="/contact" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:opacity-70' : 'text-white/90 hover:text-white'}`}>
              联系我们
            </a>
            <a 
              href="/login" 
              className={`text-sm font-medium px-5 py-2 rounded-full transition-all ${isScrolled ? 'bg-teal-600 text-white hover:bg-teal-700' : 'border border-white/70 text-white hover:bg-white/20'}`}
            >
              立即登录
            </a>
          </div>
        </div>
      </nav>

      {/* Hero 顶部区域 */}
      <section className="pt-[140px] pb-16 bg-gradient-to-br from-slate-800 via-slate-700 to-teal-800">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          {/* 标签徽章 */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-teal-500/20 border border-teal-400/30 mb-6">
            <Shield className="h-4 w-4 text-teal-300" />
            <span className="text-xs font-medium text-teal-300">法律文件</span>
          </div>

          {/* 标题 */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            隐私政策
          </h1>

          {/* 描述文字 */}
          <p className="max-w-xl mx-auto text-sm md:text-base text-slate-300 leading-relaxed">
            我们致力于保护您的隐私，本政策说明了我们如何收集、使用和保护您的个人信息。
          </p>
        </div>
      </section>

      {/* 主内容区 */}
      <main className="flex-1 py-14">
        <div className="max-w-md md:max-w-2xl mx-auto px-6">
          {/* 面包屑导航 */}
          <div className="text-xs text-slate-500 mb-8">
            <a href="/" className="hover:text-teal-600 transition-colors">首页</a>
            <span className="mx-2">/</span>
            <span className="text-slate-700 font-semibold">隐私政策</span>
          </div>

          {/* 目录卡片 */}
          <div className="bg-white rounded-xl border border-slate-100 p-6 mb-10">
            <h2 className="text-sm font-semibold text-slate-500 tracking-wider uppercase mb-4">
              目录
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {privacyContent.map((item) => (
                <a 
                  key={item.id}
                  href={`#section-${item.id}`}
                  className="flex items-center gap-2 text-sm text-slate-600 hover:text-teal-600 transition-colors py-1"
                >
                  <span className="w-5 h-5 bg-teal-50 text-teal-600 rounded text-xs flex items-center justify-center">
                    {item.id}
                  </span>
                  {item.title}
                </a>
              ))}
            </div>
          </div>

          {/* 条款内容卡片 */}
          {privacyContent.map((item) => (
            <div key={item.id} id={`section-${item.id}`} className="bg-white rounded-xl border border-slate-100 p-7 mb-8">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-7 h-7 bg-teal-500 text-white rounded-lg text-xs font-bold flex items-center justify-center">
                  {item.id}
                </span>
                <h3 className="text-base font-bold text-slate-800">
                  {item.title}
                </h3>
              </div>
              <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-line">
                {item.content}
              </p>
            </div>
          ))}

          {/* 底部提示卡片 */}
          <div className="bg-teal-50 border border-teal-100 rounded-xl p-6 text-center mt-10">
            <HelpCircle className="h-5 w-5 text-teal-500 mx-auto mb-2 block" />
            <p className="text-sm text-teal-700 leading-relaxed">
              如您对本隐私政策有任何疑问，欢迎
              <a href="/contact" className="font-medium underline hover:text-teal-900 cursor-pointer mx-1">
                联系我们
              </a>
              ，我们将在 7 个工作日内回复。
            </p>
          </div>
        </div>
      </main>

      {/* 底部导航 */}
      <footer className="bg-slate-800 text-white py-8">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* 左侧：Logo和品牌信息 */}
            <div className="flex items-center gap-3">
              <img 
                src={logoUrl} 
                alt="Logo" 
                className="h-8 w-auto"
              />
              <div>
                <div className="font-semibold text-lg">{siteName}</div>
                <div className="text-xs text-slate-400">让每一笔业务都有据可查</div>
              </div>
            </div>

            {/* 右侧：导航链接 */}
            <div className="flex flex-wrap gap-6 text-sm text-slate-400">
              <a href="/terms" className="hover:text-white transition-colors">服务条款</a>
              <a href="/privacy" className="hover:text-white transition-colors">隐私政策</a>
              <a href="/help" className="hover:text-white transition-colors">帮助中心</a>
              <a href="/contact" className="hover:text-white transition-colors">联系我们</a>
              <a href="/about" className="hover:text-white transition-colors">关于我们</a>
            </div>
          </div>

          {/* 底部备案信息 */}
          <div className="border-t border-slate-700 mt-8 pt-6 text-center text-xs text-slate-500">
            <SiteFiling />
          </div>
        </div>
      </footer>
    </div>
  );
}
